import { EntityRepository, Repository } from "typeorm";
import { PeelingSamples } from "../entities/peeling-samples.entity";

@EntityRepository(PeelingSamples)
export class PeelingSamplesRepository extends Repository<PeelingSamples> {

}